import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(() => {
  const testimonialsCarousels = document.querySelectorAll(
    '.block-testimonials .block-testimonials__carousel'
  );

  if (0 < testimonialsCarousels.length) {
    testimonialsCarousels.forEach((testimonialsCarousel) => {
      new Swiper(testimonialsCarousel, {
        slidesPerView: 1.15,
        spaceBetween: 20,
        pagination: {
          el: '.block-testimonials .vtx-swiper__pagination',
          type: 'fraction',
        },
        navigation: {
          nextEl: '.block-testimonials .swiper-button-next.vtx-swiper__next',
          prevEl: '.block-testimonials .swiper-button-prev.vtx-swiper__prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 2.25,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        },
      });
    });
  }
});
